<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-surgeries-idika-list />
<!-- <p-confirmDialog key="assignSurgerySavedMsg" [style]="{ width: '700px' }"></p-confirmDialog> -->
